import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as records from '../records'
import * as rules from '../rules'

import { Api } from './api.service'
import type { Context, TypeParams } from './types'

@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const recordsEc = ngCore.inject(records.Collection)
    const rulesEc = ngCore.inject(rules.Collection)

    /**
     * Represents the current rule or record in the slideout
     */
    const context$: rxjs.Observable<Context> = rxjs.merge(
      // Rule
      rulesEc.plugins.currentEntityPlugin.feature.selectors
        .getId()
        .asObservable.pipe(
          // And we combine that with the general context to get the
          // specific context of a GL rule
          rxjs.map(
            ruleId =>
              (ruleId === undefined ? undefined : { ruleId }) satisfies Context,
          ),
        ),
      // GL record
      recordsEc.plugins.currentEntityPlugin.feature.selectors
        .getId()
        .asObservable.pipe(
          // And we combine that with the general context to get the
          // specific context of a GL record
          rxjs.map(
            recordId =>
              (recordId === undefined
                ? undefined
                : { recordId }) satisfies Context,
          ),
        ),
    )

    super({
      api: ngCore.inject(Api),
      context$,
      identify: entity => entity.id,
      name: ec.Name.Predefined.RateGlMappingEntry,
      plugins: {
        additionalFactories: [new ds.table.ec.Factory()],
      },
    })
  }
}
